import { render, staticRenderFns } from "./ElectricalDamagesQuestion.vue?vue&type=template&id=3e81fee4"
import script from "./ElectricalDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamagesQuestion.vue?vue&type=style&index=0&id=3e81fee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports